/* eslint-disable @typescript-eslint/no-explicit-any */
// https://github.com/microsoft/TypeScript/issues/27024
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const assertType = () => undefined;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const assertNotType = () => undefined;
assertNotType();
assertType();
assertType();
assertType();
assertType();
assertNotType();
assertNotType();
assertNotType();
assertNotType();
assertNotType();
assertNotType();
assertNotType();
